/**
 * Build plain + HTML bodies for support desk ticket outbound email (Send dialog + Activity composer).
 * Matches template wrapping with %%email_body%% used in Support Desk Module email templates.
 */
import { stripHtml } from './noteQuill';

export const SUPPORT_DESK_EMAIL_BODY_PLACEHOLDER = '%%email_body%%';

export function compactSupportDeskEmailHtml(html: string): string {
  return html.replace(/<p>/gi, '<p style="margin:0 0 0.35em 0">');
}

export type SupportDeskEmailTemplateBody = { body: string };

/**
 * @param userMessage — HTML or plain from the composer (e.g. ReactQuill value)
 * @param selectedTemplate — When null/undefined, the user message is the entire body (same as Send dialog without template)
 */
export function buildSupportDeskTicketEmailBodies(
  userMessage: string,
  selectedTemplate: SupportDeskEmailTemplateBody | null | undefined
): { body: string; body_html: string | undefined } {
  const trimmed = userMessage.trim();
  if (selectedTemplate?.body?.includes(SUPPORT_DESK_EMAIL_BODY_PLACEHOLDER)) {
    const userPlain = /<[^>]+>/.test(trimmed) ? stripHtml(trimmed) : trimmed;
    const userHtml = /<[^>]+>/.test(trimmed) ? trimmed : undefined;
    const combinedBody = selectedTemplate.body.replace(
      /%%email_body%%/g,
      userHtml ?? `<p>${userPlain.replace(/\n/g, '</p><p>')}</p>`
    );
    return {
      body: stripHtml(combinedBody),
      body_html: compactSupportDeskEmailHtml(combinedBody),
    };
  }
  return {
    body: /<[^>]+>/.test(trimmed) ? stripHtml(trimmed) : trimmed,
    body_html: /<[^>]+>/.test(trimmed) ? compactSupportDeskEmailHtml(trimmed) : undefined,
  };
}
